import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../img/mb_logo.svg";
import { MdContactMail, MdInfo } from "react-icons/md"; // Импорт иконок


const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const scrollToStagePicker = () => {
    const stagePickerElement = document.getElementById("buehnen");
    if (stagePickerElement) {
      stagePickerElement.scrollIntoView({ behavior: "smooth", block: 'center' });
    }
  };

  return (
    <header>
      <nav>
        <div className="logo">
          <Link to="/" onClick={closeMenu}>
            <img src={logo} alt="Logo" />
          </Link>
        </div>
        <div className={`nav-links ${isMenuOpen ? "open" : ""}`}>
          <ul>

            <li>
              <Link to="/kontakt" onClick={closeMenu} aria-label="Kontakt">
                <MdContactMail className="icon" />
                <span className="link-text">Kontakt</span>
              </Link>
            </li>
            <li>
              <Link to="/impressum" onClick={closeMenu} aria-label="Impressum">
                <MdInfo className="icon" />
                <span className="link-text">Impressum</span>
              </Link>
            </li>
          </ul>
        </div>
        <div className={`hamburger ${isMenuOpen ? "open" : ""}`} onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
      </nav>
    </header>
  );
};

export default Header;


//   import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import logo from "../img/mb_logo.svg";
// // import "./Header.css"; // Убедитесь, что вы создали этот файл

// const Header = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);

//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   const closeMenu = () => {
//     setIsMenuOpen(false);
//   };

//   const scrollToStagePicker = () => {
//     const stagePickerElement = document.getElementById("buehnen");
//     if (stagePickerElement) {
//       stagePickerElement.scrollIntoView({ behavior: "smooth", block: 'center' });
//     }
//   };

//   return (
//     <header>
//       <nav className="navbar">
//         <div className="logo">
//           <Link to="/" onClick={closeMenu}>
//             <img src={logo} alt="Logo" />
//           </Link>
//         </div>
//         <div className={`nav-links ${isMenuOpen ? "open" : ""}`}>
//           <ul>
//             {/* Раскомментируйте и добавьте другие ссылки при необходимости */}
//             {/* <li>
//               <Link to="/register" onClick={closeMenu}>Registration</Link>
//             </li>
//             <li>
//               <button className="stagesLink" onClick={() => { scrollToStagePicker(); closeMenu(); }}>
//                 Bühnen
//               </button>
//             </li> */}
//             <li>
//               <Link to="/about" onClick={closeMenu}>Kontakt</Link>
//             </li>
//             <li>
//               <Link to="/impressum" onClick={closeMenu}>Impressum</Link>
//             </li>
//           </ul>
//         </div>
//         <div className={`hamburger ${isMenuOpen ? "open" : ""}`} onClick={toggleMenu}>
//           <span className="bar"></span>
//           <span className="bar"></span>
//           <span className="bar"></span>
//         </div>
//       </nav>
//     </header>
//   );
// };

// export default Header;
